const routes = [
    {
        path: "/other/payments",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true ,
            permission: 'otherpayment_index'
        }
    }
];

export default routes;
